import { Component, OnInit, Inject } from '@angular/core';
import { VoucherAutomaticoService } from 'src/app/services/voucher-automatico.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { VoucherAutomatico } from 'src/app/models/voucher-automativo';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { Segmentacao } from 'src/app/models/segmentacao';
import { TemplateEmailService } from 'src/app/services/template-email.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-voucher-automatico-modal',
  templateUrl: './cadastrar-voucher-automatico-modal.component.html',
  styleUrls: ['./cadastrar-voucher-automatico-modal.component.scss']
})
export class CadastrarVoucherAutomaticoModalComponent implements OnInit {

  idVoucherAutomatico: number;

  voucher: VoucherAutomatico;

  tiposDesconto = [
    { id: 0, nome: '% sobre o pedido' },
    { id: 1, nome: 'R$ sobre o pedido' },
  ];

  tiposVoucherAutomatico = [
    // { id: 0, nome: 'A cada valor' },
    // { id: 1, nome: 'A cada quantidade' },
    { id: 2, nome: 'Atingir classificação' },
  ];

  classificacoes: Segmentacao[] = [];

  templatesEmail = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<CadastrarVoucherAutomaticoModalComponent>,
    private voucherAutomaticoService: VoucherAutomaticoService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private segmentacaoService: SegmentacaoService,
    private templateEmailService: TemplateEmailService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data && this.data.idVoucherAutomatico) {
      this.idVoucherAutomatico = this.data.idVoucherAutomatico;
      this.buscarVoucherAutomatico();
    } else {
      this.voucher = new VoucherAutomatico();
      this.voucher.tipo = 2;
    }
  }

  ngOnInit(): void {
    this.buscarClassificacao();
    this.buscarTemplatesEmail();
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultar().subscribe(dados => {
      this.classificacoes = dados;
      this.carregandoService.esconde('buscarClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTemplatesEmail() {
    this.carregandoService.mostra('buscarTemplatesEmail');

    this.templateEmailService.consultarTemplates().subscribe(dados => {
      this.templatesEmail = dados;
      this.carregandoService.esconde('buscarTemplatesEmail');
    }, (erro) => {
      this.carregandoService.esconde('buscarTemplatesEmail');
      this.notificacaoService.erro(erro);
    });
  }

  buscarVoucherAutomatico() {
    this.carregandoService.mostra('buscarVoucherAutomatico');

    this.voucherAutomaticoService.consultarPorId(this.idVoucherAutomatico).subscribe(
      voucher => {
        this.voucher = voucher;
        this.carregandoService.esconde('buscarVoucherAutomatico');
      },
      err => {
        this.carregandoService.esconde('buscarVoucherAutomatico');
        this.notificacaoService.erro(err);
      }
    );
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.voucher.valorMinimoPedido = Number(this.voucher.valorMinimoPedido);
    this.voucher.valor = Number(this.voucher.valor);

    this.voucherAutomaticoService.salvar(this.voucher).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.dialogRef.close(this.voucher);
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
